export const columnOrderEn = {
  orderByDeadline: 'Deadline',
  orderByOld: 'Old ones first',
  orderByNew: 'New ones first',
  orderByExecutor: 'Executor',
  orderByTimeInColumn: 'Time in column',
  orderByAZ: 'A→Z',
  orderByZA: 'Z→A',
  orderByDateCreation: 'Creation date',
  orderByDone: 'Done',
  orderFirstCompleted: 'First completed',
  orderFirstUnfulfilled: 'First unfulfilled',
  orderByTaskName: 'Name',
  orderByAuthor: 'Author',
  orderByFavorites: 'Favorites',
  orderByAssigners: 'Assigners',
  orderByAsc: 'Ascending',
  orderByDesc: 'Descending',
  confirmPopupTitle: 'Attention!',
  confirmPopupContent:
    'You will not be able to return the current order of tasks after applying sorting',
  disableColumnSortDialog: "Don't show this message again"
}

export const columnOrderRu: typeof columnOrderEn = {
  orderByDeadline: 'Дедлайну',
  orderByOld: 'Сначала старые',
  orderByNew: 'Сначала новые',
  orderByExecutor: 'Исполнителю',
  orderByTimeInColumn: 'Времени в колонке',
  orderByAZ: 'А→Я',
  orderByZA: 'Я→А',
  orderByDateCreation: 'Дате создания',
  orderByDone: 'Выполненности',
  orderFirstCompleted: 'Сначала выполненные',
  orderFirstUnfulfilled: 'Сначала невыполненные',
  orderByTaskName: 'Названию',
  orderByAuthor: 'Автору',
  orderByFavorites: 'По избранным',
  orderByAssigners: 'По исполнителям',
  orderByAsc: 'Возрастание',
  orderByDesc: 'Убывание',
  confirmPopupTitle: 'Внимание!',
  confirmPopupContent:
    'Вы не сможете вернуть текущий порядок задач после применения сортировки',
  disableColumnSortDialog: 'Больше не показывать это сообщение'
}
